/**
 * Portraits témoignages (Unsplash, licence libre) — prises au Maroc / profils maghrébins.
 * sarah: Rabat · mohammed: Rabat · karim: Casablanca
 */
export const TESTIMONIAL_AVATARS = {
  sarah: "/images/testimonials/sarah.jpg",
  mohammed: "/images/testimonials/mohammed.jpg",
  karim: "/images/testimonials/karim.jpg",
} as const;

export type TestimonialAvatarKey = keyof typeof TESTIMONIAL_AVATARS;
